/**
 *
 * @param { value: valueToValidate, message: 'CustomErrorMessage' } opts
 * @returns { valid: true/false, messages: Array}
 */

export default class LengthValidator {
	constructor(opts) {
		this.validateOn = 'change';
		this.minLength = 0;
		this.maxLength = Number.MAX_SAFE_INTEGER;
        this.allowEmpty = false;

		if (opts) {
			this.customMessage = opts.message;

			if (opts.validateOn) {
				this.validateOn = opts.validateOn;
			}

			if (opts.minLength) {
				this.minLength = opts.minLength;
			}
			if (opts.maxLength) {
				this.maxLength = opts.maxLength;
			}

			if (opts.allowEmpty) {
				this.allowEmpty = opts.allowEmpty;
			}
		}

		this.defaultMessage =
			this.minLength === this.maxLength
				? `Field must be exactly ${this.minLength} characters long`
				: `Field must be between ${this.minLength} and ${this.maxLength} characters long`;
		this.result = { valid: true };
	}

	validate(value) {
		this.value = value.toString();
		const len = this.value.length;
 
		if (this.allowEmpty && len === 0) {
			this.result.valid = true;
			return this.result;
		}

		if (len >= this.minLength && len <= this.maxLength){
			this.result.valid = true;
		} else {
			this.result.valid = false;
		}

		if (!this.result.valid) {
			if (this.customMessage) {
				this.result.messages = [this.customMessage];
			} else {
				this.result.messages = [this.defaultMessage];
			}
		}

		return this.result;
	}
}
